import { makeVar, useReactiveVar } from '@apollo/client'

const fakeLoyaltyPeriodVar = makeVar(false)

/**
 * @param {boolean} active
 */
export const setHasFakeLoyaltyPeriod = (active) => {
  fakeLoyaltyPeriodVar(Boolean(active))
}

export const useHasFakeLoyaltyPeriod = () => useReactiveVar(fakeLoyaltyPeriodVar)
